import { NgModule } from '@angular/core';
import { IndexViewComponent } from './views/index-view/index-view.component';
import { RouterModule, Routes } from '@angular/router';
import { ReferenceGuard } from './reference.guard';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import {NotFoundComponent} from './views/not-found/not-found.component';
const routes: Routes = [
  { path: '', component: IndexViewComponent, canActivate: [ReferenceGuard] },
  // { path:'overcome-depression-naturally-taper-antidepressants', component: OvercomeDepressionViewComponent,data:{noNav:true}},
  // {path: 'about', component:AboutViewComponent, canActivate: [ReferenceGuard]},
  // {path: 'about-us', component:FunnelAboutViewComponent,data:{showMainNavBar:false}},
  // {path: 'coaches', component:FunnelRebornViewComponent,data:{showMinimalBar:true}},
  // {path: 'dosage', component:DosagesViewComponent, canActivate: [ReferenceGuard],
  //   children:[
  //     {path:"", redirectTo:"benefits", pathMatch:'full'},
  //     {path:"benefits",component:BenefitsComponent,},
  //     {path:"formula",component:FormulaComponent,},
  //     {path:"spectrum",component:SpectrumComponent,},
  //     {path:"protocol",component:ProtocolComponent,},
  //   ],
    
  // },
  // {path:"protocol-coaching-1",component:FunnelProtocolComponent,data:{showMainNavBar:false}},
  // {path: "our-approach", component: OurApproachComponent, data:{showMainNavBar:false}},
  // {path:"protocol-coaching-1/:category",component:FunnelProtocolsTestimoniesComponent,data:{showMainNavBar:false}},
  // {path:"dosage/protocol/:category",component:ProtocolsTestimoniesComponent},
  // {path: 'treatment', component:TreatmentViewComponent, canActivate: [ReferenceGuard]},
  // {path: 'coaches', component: CoachesComponent, canActivate: [ReferenceGuard]},
  // {path: 'therapeutic-support', component: TherapistsComponent, canActivate: [ReferenceGuard]},
  // {path: 'faq', component:FaqsViewComponent, canActivate: [ReferenceGuard]},

  {path: 'welcome' , component: ForbiddenComponent},
  {path: 'r/:reference' , component: IndexViewComponent, canActivate: [ReferenceGuard]},

  {path:'**', pathMatch:'full', component:NotFoundComponent, canActivate: [ReferenceGuard], title:'Bhavani 404-Not Found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 80],
    onSameUrlNavigation: "reload"
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
